import { ApiApplicantThreat, ApiApplicantThreatType } from "@/types/recruit/applicant.types.ts";
import {
  FontAwesomeIcon,
  Stack,
  Tag,
  Text,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export const PotentialThreatTag = ({ threats }: { threats: ApiApplicantThreat[] }) => {
  const { t } = useTranslation();

  const getThreatMessage = (type: ApiApplicantThreatType): string => {
    switch (type) {
      case ApiApplicantThreatType.mixed_characters:
        return t("ats:potential_threat_mixed_characters");
      case ApiApplicantThreatType.ai_generated_cv:
        return t("ats:potential_threat_ai_generated_cv");
      default:
        return t("ats:potential_threat_default");
    }
  };

  const isAiGeneratedCv = (threat: ApiApplicantThreat) =>
    threat.type === ApiApplicantThreatType.ai_generated_cv;

  const hasAiGeneratedCv = threats.some(isAiGeneratedCv);
  const otherThreats = threats.filter((threat) => !isAiGeneratedCv(threat));
  const messages = otherThreats.map((threat) => getThreatMessage(threat.type));

  return (
    <>
      {!!otherThreats.length && (
        <Tooltip>
          <TooltipTrigger>
            <Tag variant={"warning"} appearance={"filled"} className={"flex gap-1 cursor-default"}>
              <FontAwesomeIcon icon={"fa-light fa-user-secret"} className={"text-base"} />
              {t("ats:potential_threat")}
            </Tag>
          </TooltipTrigger>
          <TooltipContent className={"max-w-96"}>
            <Stack gap={"xs"}>
              {messages.map((message, index) => (
                <Text key={index} className={"text-white text-center"}>
                  {message}
                </Text>
              ))}
            </Stack>
          </TooltipContent>
        </Tooltip>
      )}
      {hasAiGeneratedCv && (
        <Tooltip>
          <TooltipTrigger>
            <Tag
              variant={"secondary"}
              appearance={"outline"}
              className={"flex gap-1 cursor-default"}
            >
              <FontAwesomeIcon icon={"fa-light fa-sparkles"} className={"text-base"} />
              {t("ats:potential_threat_ai_generated_cv_tag")}
              <Text className={"text-secondary text-xs"}>
                ({t("ats:potential_threat_ai_generated_cv_beta")})
              </Text>
            </Tag>
          </TooltipTrigger>
          <TooltipContent className={"max-w-96"}>
            <Stack gap={"xs"}>
              <Text className={"text-white text-center"}>
                {t("ats:potential_threat_ai_generated_cv")}
              </Text>
              <Text className={"text-white text-center text-xs opacity-70"}>
                {t("ats:potential_threat_ai_generated_cv_disclaimer")}
              </Text>
            </Stack>
          </TooltipContent>
        </Tooltip>
      )}
    </>
  );
};
